<template>
  <div>
    <Logo :parentData="pageData" />
    <BackStageMenu :parentData="pageData" />
    <div id="contents" class="clearfix">
      <div id="main_area">
        <div class="information">
          <h3>B201 申報資料明細查詢</h3>
          <div class="table_scroll2">
            <table class="newTable">
              <tbody>
                <tr>
                  <td>申報年度:</td>
                  <td colspan="3">
                    <select v-model="form.syear">
                      <option
                        v-for="(data, index) in dropDownList.syears"
                        :key="index"
                        :value="data"
                      >
                        {{ data }}
                      </option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td>身分證統一編號</td>
                  <td>
                    <input
                      type="text"
                      v-model="form.idn"
                      size="10"
                      maxlength="10"
                    />
                  </td>
                  <td>姓名</td>
                  <td>
                    <input
                      type="text"
                      v-model="form.name"
                      size="40"
                      maxlength="49"
                    />
                  </td>
                </tr>
                <tr>
                  <td colspan="6" class="f_center">
                    <input
                      type="submit"
                      class="btn"
                      value="查詢"
                      @click="doQuery()"
                    />
                    <input
                      type="submit"
                      class="btn"
                      value="重填"
                      @click="doClear()"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- 查詢結果開始-->
        <div class="information">
          <table width="100%" v-if="grid.gridDatas">
            <tbody>
              <tr>
                <td></td>
                <td align="right" v-if="grid.paginaiton">
                  <input
                    type="button"
                    value="<<"
                    class="btn"
                    style="height: 28px"
                    @click="form.currentpage = grid.paginaiton.pageNo - 1"
                    v-show="grid.paginaiton.pageNo > 1"
                  />
                  <span
                    v-for="(data, index) in grid.paginaiton.pages"
                    :key="index"
                    style="cursor: pointer"
                    :style="
                      grid.paginaiton.pageNo == data
                        ? 'color:red'
                        : 'color:black'
                    "
                    @click="form.currentpage = parseInt(data)"
                  >
                    {{
                      grid.paginaiton.pageNo == data ? "[" + data + "]" : data
                    }}
                  </span>
                  <input
                    type="button"
                    class="btn"
                    value=">>"
                    style="height: 28px"
                    v-show="grid.paginaiton.pageNo < grid.paginaiton.totalPage"
                    @click="form.currentpage = grid.paginaiton.pageNo + 1"
                  />
                  ［每頁<input
                    type="text"
                    v-model.number.lazy="form.pagesize"
                    size="2"
                    maxlength="4"
                  />

                  <input type="button" class="btn" value="筆" />，第<input
                    type="text"
                    v-model.number.lazy="form.currentpage"
                    size="2"
                    maxlength="4"
                  />
                  <input type="button" class="btn" value="頁" />，共
                  {{ grid.paginaiton.totalPage }} 頁
                  {{ grid.paginaiton.totalCount }} 筆］
                </td>
              </tr>
            </tbody>
          </table>
          <div class="active">
            <div class="table_scroll2">
              <table width="1060" class="itable">
                <thead>
                  <tr>
                    <th style="width: 50px">操作</th>
                    <th style="min-width: 80px">姓名</th>
                    <th style="min-width: 100px">身分證字號</th>
                    <th style="min-width: 50px">申報年度</th>
                    <th style="min-width: 80px">申報日期</th>
                    <th style="min-width: 80px">申報類別</th>
                    <th style="width: 230px">申報表名稱</th>
                    <th style="width: 80px">上傳時間</th>
                    <th style="width: 80px">刪除註記</th>
                    <th style="width: 80px">序號</th>
                  </tr>
                </thead>
                <tbody v-if="grid.gridDatas && grid.gridDatas.length > 0">
                  <tr v-for="(data, index) in grid.gridDatas" :key="index">
                    <td>
                      <input
                        type="button"
                        class="btn"
                        value="列印"
                        @click="doPrint(data)"
                      />
                      <input
                        type="button"
                        class="btn"
                        @click="btnEdit(data)"
                        value="修改服務機關"
                      />
                      <input
                        type="button"
                        class="btn"
                        @click="btnSaveYear(data)"
                        value="修改年度"
                      />
                    </td>
                    <td>{{ data.name }}</td>
                    <td>{{ data.idn }}</td>
                    <td>
                      <select v-model="data.syear">
                        <option
                          v-for="(data, index) in dropDownList.syears"
                          :key="index"
                          :value="data"
                        >
                          {{ data }}
                        </option>
                      </select>
                    </td>
                    <td>{{ data.sdate }}</td>
                    <td>{{ data.dtypename }}</td>
                    <td>{{ data.kindname }}</td>
                    <td>{{ data.datetimestr }}</td>
                    <td>{{ data.delFlag }}</td>
                    <td>{{ data.seqno }}</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="9" style="text-align: center">查無資料</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- 查詢結果結束-->
        </div>
      </div>
      <!-- 頁籤結束 -->
    </div>
    <CyFooter />

    <DetailModal
      v-model="DetailModal.show"
      :title="DetailModal.title"
      :modalStyle="{ 'max-width': '1000px' }"
      :ServiceUnit="pageData.ServiceUnit"
    >
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td>服務機關</td>
                <td>
                  <input type="text" v-model="DetailModal.form.govagency" />
                </td>
                <td>職稱</td>
                <td>
                  <input type="text" v-model="DetailModal.form.title" />
                </td>
              </tr>
              <tr>
                <td colspan="6" class="f_center">
                  <label for="checkbox"
                    ><span>
                      <input
                        type="submit"
                        class="btn"
                        value="修改"
                        @click="btnModalSave()" /></span
                  ></label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
      <div class="information">
        <div class="active">
          <div class="table_scroll2">
            <table width="1060" class="itable">
              <thead>
                <tr>
                  <th colspan="1">操作</th>
                  <th>序號</th>
                  <th>服務機關</th>
                  <th>職稱</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(data, index) in DetailModal.grid" :key="index">
                  <td width="1%" align="center">
                    <input
                      type="button"
                      class="btn"
                      value="編"
                      @click="btnModalEdit(data)"
                    />
                  </td>
                  <td>{{ data.seqno }}</td>
                  <td>{{ data.govagency }}</td>
                  <td>{{ data.title }}</td>
                </tr>
                <tr v-if="!DetailModal.grid || !DetailModal.grid.length">
                  <td colspan="7" style="text-align: center">查無資料</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- 查詢結果結束-->
      </div>
    </DetailModal>

    <Alert
      v-model="Alert.show"
      :title="Alert.title"
      :ServiceUnit="pageData.ServiceUnit"
    >
      <div style="text-align: center">
        <div
          v-for="(data, index) in Alert.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Alert.BtnConfirm">確定</button>
        </div>
      </div>
    </Alert>
  </div>
</template>

<script>
import VueModal from "@/components/Common/vue-modal.vue";
import Logo from "@/components/Common/Logo.vue";
import BackStageMenu from "@/components/BackStage/BackStageMenu.vue";
import CyFooter from "@/components/Common/CyFooter.vue";
import { getMenuIndex } from "@/config/util.js";
import {
  B201_SearchGrid,
  PrintReport,
  B201_SearchDxServiceUnits,
  B201_UpdateDxServiceUnits,
  B201_UpdateMain
} from "@/service/api.js";
export default {
  name: "B201",
  data: function () {
    return {
      pageData: {
        MenuIndex: 1,
        PrgName: "B201",
        ServiceUnit: "CY",
        isForceLoginOut: true,
      },
      loginInfo: JSON.parse(sessionStorage.getItem("LoginInfo"))
        ? JSON.parse(sessionStorage.getItem("LoginInfo"))
        : "",
      form: {
        syear: String(new Date().getFullYear() - 1911),
        idn: "",
        name: "",
        pagesize: 10,
        currentpage: 1,
      },
      dropDownList: {
        syears: [],
      },
      grid: {},
      DetailModal: {
        show: false,
        title: "",
        form: {
          seqno: 0,
          fno: "",
          govagency: "",
          title: "",
          pkno: 0,
        },
        grid: {},
        PreData: {},
      },
      Alert: {
        show: false,
        title: "",
        txt: [],
        BtnConfirm: function () {
          this.show = false;
        },
      },
    };
  },
  components: {
    Logo,
    BackStageMenu,
    DetailModal: VueModal,
    CyFooter,
    Alert: VueModal,
  },
  methods: {
    getSyearDropDownList: function () {
      let syears = [];
      const startYear = 99;
      for (let i = startYear; i <= new Date().getFullYear() - 1911; i++) {
        syears.push(i.toString().length === 2 ? "0" + i : i.toString());
      }
      return syears;
    },
    //查詢
    doQuery: function () {
      const self = this;
      let postData = {
        IDN: self.form.idn,
        SYEAR: self.form.syear,
        NAME: self.form.name,
        CURRENTPAGE: self.form.currentpage,
        PAGESIZE: parseInt(self.form.pagesize),
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      B201_SearchGrid(postData).then((rData) => {
        self.grid = rData.returnObject;
      });
    },
    btnEdit: function (data) {
      const self = this;
      self.DetailModal.PreData = data;
      B201_SearchDxServiceUnits({
        seqno: data.seqno,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "編",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      }).then((rData) => {
        if (rData.result) {
          self.DetailModal.grid = rData.returnObject;
          self.DetailModal.form = {
            fno: self.DetailModal.grid.fno,
            govagency: self.DetailModal.grid.govagency,
            title: self.DetailModal.grid.title,
            pkno: self.DetailModal.grid.pkno,
            seqno: self.DetailModal.grid.seqno,
          };
          self.DetailModal.title = "服務機關-編輯";
          self.DetailModal.show = true;
        }
      });
    },
    doClear: function (data) {
      const self = this;
      self.form.syear = String(new Date().getFullYear() - 1911);
      self.form.idn = "";
      self.form.name = "";
      self.form.pagesize = 10;
      self.form.currentpage = 1;
    },
    doPrint: function (data) {
      const self = this;
      let postData = {
        serviceUnit: "CY",
        seqno: data.seqno,
        printType: "R",
        unit: "",
        id:self.loginInfo.id,
      };
      PrintReport(postData).then((rData) => {
        var link = document.createElement("a");
        link.download = data.idn + "_" + data.seqno;
        link.href = "data:application/pdf;base64," + rData;
        link.click();
      });
    },
    btnSaveYear: function (data) {
      const self = this;
      let postData = {
        pkno: data.pkno,
        SYEAR: data.syear,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      B201_UpdateMain(postData).then((rData) => {
        var msg = [];
        debugger;
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          msg.push("修改成功");
          self.Alert.txt = msg;
          self.doQuery();
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          msg.push("修改失敗");
          self.Alert.txt = msg;
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    btnModalEdit: function (data) {
      const self = this;
      self.DetailModal.form.govagency = data.govagency;
      self.DetailModal.form.title = data.title;
      self.DetailModal.form.pkno = data.pkno;
      self.DetailModal.form.seqno = data.seqno;
    },
    btnModalSave: function () {
      const self = this;
      let errorMsg = [];
      debugger;
      if (self.DetailModal.form.pkno == 0) {
        errorMsg.push("請先點選編,在進行資料修正");
      }

      if (self.DetailModal.form.govagency == "") {
        errorMsg.push("請填寫服務機關");
      }

      if (self.DetailModal.form.title == "") {
        errorMsg.push("請填寫職稱");
      }

      //test

      if (errorMsg.length > 0) {
        self.Alert.txt = errorMsg;
        self.Alert.show = true;
        self.Alert.title = "提醒";
        self.Alert.BtnConfirm = () => (self.Alert.show = false);
        return false;
      }

      let postData = {
        govagency: self.DetailModal.form.govagency,
        title: self.DetailModal.form.title,
        pkno: self.DetailModal.form.pkno,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "第二頁修改-修改序號為:" + self.DetailModal.form.seqno,
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      B201_UpdateDxServiceUnits(postData).then((rData) => {
        var msg = [];
        debugger;
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          msg.push("修改成功");
          self.Alert.txt = msg;
          self.btnEdit(self.DetailModal.PreData);
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          msg.push("修改失敗");
          self.Alert.txt = msg;
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
  },
  created() {
    const self = this;
    //RoleAuthorizeMenu
    self.pageData.MenuIndex = getMenuIndex(self.pageData.PrgName);
    if (self.pageData.MenuIndex === null) {
      self.Alert.show = true;
      self.Alert.title = "訊息";
      self.Alert.txt = ["無進入此頁權限，請洽詢管理員!!"];
      self.Alert.BtnConfirm = () => {
        self.Alert.show = false;
        self.$router.go(-1);
      };
    }
    self.dropDownList.syears = self.getSyearDropDownList();
    //self.doQuery();
  },
  watch: {
    "form.currentpage": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.doQuery();
      }
    },
    "form.pagesize": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.doQuery();
      }
    },
  },
};
</script>

<style scoped src="@/assets/css/Cy.css" />
